import React, { useState } from "react";
import { Divider, Grid, Backdrop } from "@mui/material";
import { CircularProgress } from "@mui/material";
import {ThemeProvider, createTheme} from "@mui/material";
import {Tab, Box} from "@mui/material";
import {TabPanel, TabContext, TabList} from "@mui/lab";
import "../../Reports/Reports.css";
import { styled } from '@mui/material/styles';
import StandAloneCareFacility from "./StandAloneCareFacility";
import ParentCareFacility from "./ParentCareFacility";
import { getCareFacilityList } from "../../common/constants/globalconstants";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import { useLocation, useParams } from "react-router-dom";

const StyledTabList = styled(TabList)({
    borderBottom: '1px solid #e8e8e8',
    left: "2%",
    '& .MuiTabs-indicator': {
      backgroundColor: '#1890ff',
      height:0
    },
  });

  const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    //marginRight: theme.spacing(1),
    color: 'rgba(0, 0, 0, 0.85)',
    backgroundColor: "#ffffff",
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      //color: '#40a9ff',
      opacity: 1,
    },
    '&.Mui-selected': {
      color: '#000000',
      fontWeight: "650",      
      backgroundColor: "#f1f1f1",
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#000000',
    },
  }));
const theme = createTheme();

export default function NewCareFacility(){
const [value, setValue] = useState('parentCareFacility');
const [loading, setLoading] = useState(false);
const [carefacilityList, setCarefacilityList] = useState([]);
const [carefacilityRecords, setCarefacilityRecords] = useState([]);
const [rightListForEdit, setRightListForEdit] = useState([]);
const [errormodalopen, seterrormodalOpen] = useState(false);   
 const { action } = useParams();
 const location = useLocation();

React.useEffect( () => {
  const fetchCareFacilityDetails = async() => {
    try{
      setLoading(true);
      const resp = await axiosInstance.get(`${getCareFacilityList}`);
      if(resp.data.isSuccess){
      setCarefacilityRecords(resp.data.result.careFacilityList);
      const filteredList = filterChildCompanies(resp.data.result.careFacilityList);
      setCarefacilityList(filteredList); //success fetching data 
      }
      else if(!resp.data.isSuccess){
        seterrormodalOpen(true);
      }      
      setLoading(false);
    }
    catch(err) {
        console.log(err.message);
        setLoading(false);
        seterrormodalOpen(true);
  }
  }

  fetchCareFacilityDetails();	
}, [action])

React.useEffect(() => {
  if(action == "edit"){
    
    if(location.state.isParent == "YES"){
       const childList = location.state.childList;
       if(location.state.isParent == "YES" && Object.keys(childList).length !==0){
        const keys = Object.keys(childList);
        const keySet = new Set(keys.map(String));
        const filteredList = carefacilityRecords.filter(item => keySet.has(item.id));
        const sortedList = sortInAlphabeticalOrder(filteredList);
        setRightListForEdit(sortedList);
       }
      
      setValue("parentCareFacility");
    }else{
      setValue("standAloneCareFacility");
    }
  }
},[carefacilityRecords])

const handleChange = (event, newValue) =>{
  setValue(newValue);
}

const filterChildCompanies = (resultList) =>{
  const filteredList = resultList.filter(item => item.isStandAlone === "YES");
  const sortedList = sortInAlphabeticalOrder(filteredList);
  return sortedList;
}

const sortInAlphabeticalOrder = (filteredList) => {
  const compNameList = filteredList.map(item => ({...item, companyName: item.companyName.toUpperCase()}))
  .sort((a,b) => a.companyName.localeCompare(b.companyName));
  return compNameList;
}

    return(
        <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "2%",
          flexDirection: "column",
          width: "95%",
          marginTop: "15px",
          marginBottom: "20px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
            <h2 className="header">{action === "edit"? "Update Care Facility" : "Add Care Facility"}</h2>
            <Divider
                variant="fullwidth"
                sx={{ backgroundColor: "#dfe3e8" }}
                ></Divider> 
          
          <div>
           <Grid 
            item
            xs={10}
            sx={{
              p: "3px 0px",
              //border: "1.5px solid #dfe3e8",
              //borderRadius: "5px",
              backgroundColor: "white",
              marginTop: "5px",
              marginBottom: "5px"
            }}>
                      

                <Grid xs={12}>
                {/* <ActiveCounts /> */}
                <div style={{marginTop: "15px", border: "1px solid #dfe3e8", borderRadius: "5px",}}>  
                <Box display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}> 
                <ThemeProvider theme={theme}>
                <Box sx={{width: "100%"}}>
                <TabContext value={value}
                >
                <Box sx={{borderBottom: "1"}}>
                  <StyledTabList
                    onChange={handleChange}
                    >
                      <StyledTab 
                      variant="fullwidth" 
                      value="parentCareFacility" 
                      label="Parent"                      
                      disabled={action == "edit" && location.state.isParent == "NO"}></StyledTab>
                      <StyledTab 
                      variant="fullwidth" 
                      value="standAloneCareFacility" 
                      label="Stand Alone"
                      disabled={action == "edit" && location.state.isParent == "YES"}
                      ></StyledTab>
                    </StyledTabList>
                </Box>  
                {loading && (
                  <>
                <Backdrop
                  sx={{
                    color: "white",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={true}
                >
                  <CircularProgress sx={{ color: "white" }} />
                  <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading... </span>
                </Backdrop>
                </>
                )}

                  <TabPanel 
                  sx={{p:"10px 0px"}}
                  value="parentCareFacility">                  
                  <Box>
                    <ParentCareFacility 
                    carefacilityList={carefacilityList}
                    setCarefacilityList={setCarefacilityList}
                    carefacilityRecords={carefacilityRecords}
                    setCarefacilityRecords={setCarefacilityRecords}
                    rightListForEdit={rightListForEdit}
                    sortInAlphabeticalOrder={sortInAlphabeticalOrder}/>
                  </Box>
                  </TabPanel>
                  <TabPanel 
                  sx={{p:"10px 0px"}}
                  value="standAloneCareFacility">
                  <Box>
                    <StandAloneCareFacility/>
                  </Box>          
                  </TabPanel>
                </TabContext>
                </Box>
                </ThemeProvider>
                </Box>
                </div>
              </Grid>
            </Grid>
           
            
          </div> 
            {errormodalopen && (
            <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
             )}
         {/* </div> */}
        </Box>
    )
}